import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b128b5f0")

_pushScopeId("data-v-b128b5f0")
const _hoisted_1 = { class: "info-padding" }
const _hoisted_2 = { class: "edit-model" }
const _hoisted_3 = { class: "info-title-bottom display-flex" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "flex1" }
const _hoisted_6 = { class: "info-title-bottom" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  key: 0,
  class: "info-title-bottom"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "info-title-bottom" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "info-title-bottom" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "delete-model info-title-bottom"
}
const _hoisted_16 = { class: "info-title-bottom display-flex" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "flex1" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_21 = { class: "display-flex info-title-havbutton-bottom" }
const _hoisted_22 = { class: "title" }
const _hoisted_23 = { class: "flex1 display-flex justify-content-end" }
const _hoisted_24 = { class: "info-title-bottom" }
const _hoisted_25 = { class: "display-flex info-title-havbutton-bottom" }
const _hoisted_26 = { class: "title" }
const _hoisted_27 = { class: "flex1 display-flex justify-content-end" }
const _hoisted_28 = {
  key: 0,
  class: "status-on"
}
const _hoisted_29 = {
  key: 1,
  class: "status-off"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_add_button = _resolveComponent("add-button")
  const _component_list = _resolveComponent("list")
  const _component_user_info_third_party_devices = _resolveComponent("user-info-third-party-devices")
  const _component_add_room_dialog = _resolveComponent("add-room-dialog")
  const _component_familymember_dialog = _resolveComponent("familymember-dialog")
  const _component_pay_app = _resolveComponent("pay-app")
  const _component_payment_tips_dialog = _resolveComponent("payment-tips-dialog")
  const _component_device_set_dialog = _resolveComponent("device-set-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$wordList.DeviceDetailDetailUnitName), 1),
        _createVNode("label", _hoisted_5, _toDisplayString(_ctx.details.UnitName), 1),
        _createVNode("span", {
          class: "el-icon-edit right",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.modifyUser && _ctx.modifyUser(...args)))
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$wordList.RDeviceSearchLabelRoomName), 1),
        _createVNode("label", null, _toDisplayString(_ctx.details.RoomName) + _toDisplayString(_ctx.details.Floor ? ` (${_ctx.$wordList.Floor} ${_ctx.details.Floor}) ` : ''), 1)
      ]),
      (_ctx.isNew)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$wordList.WebRelayID), 1),
            _createVNode("label", null, _toDisplayString(_ctx.details.WebRelayID), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_10, [
        _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$wordList.ProperAllTextCallType), 1),
        _createVNode("label", null, _toDisplayString(_ctx.callTypeOptions[Number(_ctx.details.CallType)]), 1)
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$wordList.ProperAllTextSipIpCall), 1),
        _createVNode("label", null, _toDisplayString(_ctx.sipIpCallOptions[Number(_ctx.details.EnableIpDirect)]), 1)
      ])
    ]),
    _hoisted_14,
    (_ctx.showFamilyMembers)
      ? (_openBlock(), _createBlock("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$wordList.ProperAllTextFamilySIPNumber), 1),
            _createVNode("label", _hoisted_18, _toDisplayString(_ctx.details.SipGroup), 1),
            _createVNode("span", {
              class: "el-icon-delete right",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteUser && _ctx.deleteUser(...args)))
            })
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.familyInfo, (item, index) => {
            return (_openBlock(), _createBlock("div", { key: item }, [
              (_ctx.isEnableLandline == 1 || item.name != 'Phone')
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: [index!=_ctx.familyInfo.length-1?'info-title-bottom':'']
                  }, [
                    _createVNode("label", _hoisted_19, _toDisplayString(item.title), 1),
                    _createVNode("label", null, _toDisplayString(item.content), 1)
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _hoisted_20,
          _createVNode("div", _hoisted_21, [
            _createVNode("label", _hoisted_22, _toDisplayString(_ctx.subUsers.length) + " " + _toDisplayString(_ctx.$wordList.NavInHtmlMenuUser2), 1),
            _createVNode("div", _hoisted_23, [
              _createVNode(_component_add_button, {
                onClick: _ctx.addFamilyMember,
                class: "info-title-button"
              }, null, 8, ["onClick"])
            ])
          ]),
          _createVNode(_component_list, {
            headers: _ctx.userHeaders,
            listData: _ctx.subUsers,
            showDefaultAction: [],
            action: _ctx.userAction,
            update: _ctx.updateList,
            showCheck: false,
            onEdit: _ctx.editUser
          }, null, 8, ["headers", "listData", "action", "update", "onEdit"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_24, [
      _createVNode("div", _hoisted_25, [
        _createVNode("label", _hoisted_26, _toDisplayString(_ctx.devices.length) + " " + _toDisplayString(_ctx.$wordList.IntercomDevices), 1),
        _createVNode("div", _hoisted_27, [
          _createVNode(_component_add_button, {
            onClick: _ctx.addDevice,
            class: "info-title-button"
          }, null, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_list, {
        headers: _ctx.deviceHeaders,
        listData: _ctx.devices,
        showDefaultAction: [],
        update: _ctx.updateList,
        showCheck: false,
        action: _ctx.deviceAction,
        onEdit: _ctx.editDevice,
        onInfo: _ctx.infoDevice
      }, {
        LocationSlotHeader: _withId((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getSortRes('aptInfoIntercomDevice', 'Location')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode("img", {
              src: _ctx.getSortImg('aptInfoIntercomDevice', 'Location')
            }, null, 8, ["src"])
          ])
        ]),
        CreateTimeSlotHeader: _withId((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getSortRes('aptInfoIntercomDevice', 'CreateTime')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode("img", {
              src: _ctx.getSortImg('aptInfoIntercomDevice', 'CreateTime')
            }, null, 8, ["src"])
          ])
        ]),
        TypeSlot: _withId((data) => [
          _createVNode("div", null, [
            _createVNode("img", {
              class: "margin-top15px",
              src: _ctx.DeviceTypeIcon[data.scope.Type]
            }, null, 8, ["src"])
          ])
        ]),
        StatusSlot: _withId((data) => [
          (data.scope.Status === _ctx.device.statusOn)
            ? (_openBlock(), _createBlock("div", _hoisted_28))
            : _createCommentVNode("", true),
          (data.scope.Status === _ctx.device.statusOff)
            ? (_openBlock(), _createBlock("div", _hoisted_29))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["headers", "listData", "update", "action", "onEdit", "onInfo"])
    ]),
    (_ctx.isShowThirdDevice)
      ? (_openBlock(), _createBlock("div", _hoisted_30, [
          _createVNode("label", _hoisted_31, _toDisplayString(_ctx.thirdPartyDeviceCount) + " " + _toDisplayString(_ctx.$wordList.ThirdPartyDevices), 1),
          _createVNode(_component_user_info_third_party_devices, {
            id: _ctx.id,
            "device-type": _ctx.deviceType,
            uuid: _ctx.details.UUID,
            eventBus: _ctx.eventBus,
            onSettingThirdDeviceCount: _cache[5] || (_cache[5] = ($event: any) => (_ctx.thirdPartyDeviceCount=$event))
          }, null, 8, ["id", "device-type", "uuid", "eventBus"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowAddRoomDialog)
      ? (_openBlock(), _createBlock(_component_add_room_dialog, {
          key: 2,
          initForm: _ctx.formData,
          showUser: _ctx.showFamilyMembers,
          operate: "edit",
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowAddRoomDialog = false)),
          onUpdate: _ctx.refreshUserInfo
        }, null, 8, ["initForm", "showUser", "onUpdate"]))
      : _createCommentVNode("", true),
    (_ctx.isShowAddSubUserDialog)
      ? (_openBlock(), _createBlock(_component_familymember_dialog, {
          key: 3,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowAddSubUserDialog = false)),
          onSuccess: _ctx.addUserSuccess,
          identity: "community",
          operaType: _ctx.operaType,
          details: _ctx.details,
          initForm: _ctx.subUserForm
        }, null, 8, ["onSuccess", "operaType", "details", "initForm"]))
      : _createCommentVNode("", true),
    (_ctx.isShowPay)
      ? (_openBlock(), _createBlock(_component_pay_app, {
          key: 4,
          mainId: _ctx.mainID,
          id: _ctx.payUserID,
          payUser: "community",
          onSuccess: _ctx.refreshUserInfo,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowPay=false))
        }, null, 8, ["mainId", "id", "onSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.isShowTips)
      ? (_openBlock(), _createBlock(_component_payment_tips_dialog, {
          key: 5,
          onIsShowPayNow: _ctx.isShowPayNow,
          onClose: _ctx.closePayTips,
          mainId: _ctx.mainID,
          "notice-type": _ctx.noticeType,
          "notice-main-code": _ctx.noticeMainCode
        }, null, 8, ["onIsShowPayNow", "onClose", "mainId", "notice-type", "notice-main-code"]))
      : _createCommentVNode("", true),
    (_ctx.isShowDeviceDialog)
      ? (_openBlock(), _createBlock(_component_device_set_dialog, {
          key: 6,
          operaType: _ctx.operaType,
          initForm: _ctx.initDeviceData,
          onSuccess: _ctx.refreshUserInfo,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowDeviceDialog = false)),
          identity: "community"
        }, null, 8, ["operaType", "initForm", "onSuccess"]))
      : _createCommentVNode("", true)
  ]))
})